import Card from "components/card";
import Badge from "components/badge";
import { EMPLOYMENT_STATUS_COLORS } from "variables/constants";

const ProfileHeader = ({
    initials,
    fullName,
    designation,
    clientName,
    employmentStatus,
    variant = "dark",
    empCode,
}) => {
    const isDark = variant === "dark";

    return (
       <Card className="flex gap-4 w-full">

        <span
            className={`
            relative flex
            w-16 h-16 sm:w-20 sm:h-20
            shrink-0 rounded-full overflow-hidden border
            ${
                isDark
                ? "bg-white/20 backdrop-blur-xl border-white/30 text-white shadow-xl"
                : "bg-gray-200 border-gray-300 text-slate-800"
            }
            `}
        >
            <span className="flex w-full h-full items-center justify-center font-semibold text-xl sm:text-[24px]">
            {initials}
            </span>
        </span>

        <div className="flex-1 min-w-0">

            <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2">

            <div className="min-w-0">
                <div
                className={`
                    font-semibold leading-tight
                    text-lg sm:text-[20px]
                    ${isDark ? "text-cyan-100" : "text-slate-600"}
                `}
                >
                {fullName}
                </div>

                <div
                className={`
                    mt-1 text-sm
                    ${isDark ? "text-cyan-100" : "text-slate-600"}
                `}
                >
                {designation} / {clientName}
                </div>

                <div className="mt-2">
                <Badge
                    color={EMPLOYMENT_STATUS_COLORS[employmentStatus ]}
                >
                    <span>{employmentStatus}</span>
                </Badge>
                </div>
            </div>

            {empCode && (
                <div
                className="
                    inline-flex items-center justify-center
                    px-2 py-0.5 rounded-xl border
                    bg-white/20 backdrop-blur-xl
                    text-cyan-100 text-sm font-medium
                    w-fit
                    self-start
                "
                >
                    {empCode}
                </div>
            )}

            </div>

        </div>

        </Card>
    );
};

export default ProfileHeader;
